import { deliveryWeeklyWorkingDaySelector, handleSaveDeliveryWeeklyWorkingDays } from '@/redux/slice/delivery.slice';
import { ExactTimeType } from '@/types';
import { IWeeklyWorkingDay } from '@/types/components/day';
import { Select } from '@shopify/polaris';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

type TimeSlotsType = {
  label: string;
  value: string;
};

type TimeSlotProps = {
  timeOptions: TimeSlotsType[];
  timeSlotValue: string;
  selectedWorkingDay: IWeeklyWorkingDay;
  index: number;
};

const TimeSlots = ({ timeOptions, timeSlotValue, selectedWorkingDay, index }: TimeSlotProps) => {
  const [selectTime, setSelectTime] = useState(timeSlotValue);
  const deliveryWeeklyWorkingDays = useSelector(deliveryWeeklyWorkingDaySelector);
  const dispatch = useDispatch();

  const handleSelectTime = (value: string) => {
    setSelectTime(value);
    dispatch(
      handleSaveDeliveryWeeklyWorkingDays(
        deliveryWeeklyWorkingDays.map((item) => {
          if (item.day === selectedWorkingDay?.day) {
            return {
              ...item,
              exactTimes: item.exactTimes?.map((item: ExactTimeType, idx: number) => {
                if (idx === index) {
                  return { ...item, start: value };
                }
                return item;
              }),
            };
          }
          return item;
        }),
      ),
    );
  };

  return (
    <Select
      label="Select time"
      labelHidden
      options={timeOptions}
      value={selectTime}
      onChange={(value) => handleSelectTime(value)}
    />
  );
};

export default TimeSlots;
